class AfterclubController {
    constructor() {

        this.setIntroSlider();
        this.setEventSlider();
    }

    setIntroSlider() {
        let options = {
            loop: true,
            loopAdditionalSlides: 1,
            // loopedSlides: 5,
            // freeMode: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            // centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween: (window.UA.isSP) ? 0 : 0,
            slidesPerView: 1,
            parallax: true,
            // slidesPerGroup: 1,
            // navigation: {
            //     nextEl: '#js-planners_interview-detail__pickup-slider-next',
            //     prevEl: '#js-planners_interview-detail__pickup-slider-prev',
            // },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                activeIndexChange : function(swiper){
                    let $i = $('.sustainability-content__shoene-slide-nav-progress i');
                    let max = parseInt($('.sustainability-content__shoene-slide-nav-max').text());
                    // console.log(swiper.realIndex,max);
                    $('.sustainability-content__shoene-slide-nav-current').text(`0${swiper.realIndex+1}`);
                    $i.css({
                        width: `${(swiper.realIndex+1)/max*100}%`
                    });

                }
            },
        };
        let introSlider = new Swiper('#js-afterclub-content__intro-slide', options);
        if (window.UA.isSP) {
            introSlider.off('resize');
        }
    }

    setEventSlider() {
        $('.afterclub-content__main-item-event-slider').each(function(){
            let $this = $(this);
            let $container = $this.find('.swiper-container');
            let id = $container.attr('id');
            let prev = $this.find('.afterclub-content__main-item-event-slider-prev').attr('id');
            let next = $this.find('.afterclub-content__main-item-event-slider-next').attr('id');

            let options = {
                loop: true,
                loopAdditionalSlides: 1,
                // loopedSlides: 5,
                // freeMode: true,
                // autoplay: {
                //     delay: 3000,
                //     disableOnInteraction: false,
                // },
                loopFillGroupWithBlank: false,
                // updateOnWindowResize: false,
                // width: (window.UA.isSP)? 210: 420,
                // centeredSlides: false,
                // centerInsufficientSlides: true,
                // width: (this.UA.isSP)? 190: 190,
                spaceBetween: (window.UA.isSP) ? 0 : 20,
                slidesPerView:  (window.UA.isSP) ? 1 : 2,
                // parallax: true,
                // slidesPerGroup: 1,
                navigation: {
                    nextEl: `#${next}`,
                    prevEl: `#${prev}`,
                },
                // scrollbar: {
                //     el: '#js-home-voice__slider-bar',
                //     // hide: true,
                //     draggable: false,
                // },
                touchAngle: 20,
                speed: 800,
                // pagination: {
                // el: '#js-mainvisual__slider-pagination',
                // clickable: true,
                // renderBullet: function (index, className) {
                //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
                // },
                // bulletClass: 'mainvisual__slider-pagination-bullet',
                // bulletActiveClass: 'is-active'
                // },
                // effect: 'fade',
                // fadeEffect: {
                //     crossFade: true
                // },
                on: {
                },
            };
            let introSlider = new Swiper(`#${id}`, options);
            if (window.UA.isSP) {
                introSlider.off('resize');
            }
        });
    }
}

export default AfterclubController;
